import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';

import { call } from '../utilities/http';
import { LOADING, COMPLETE, I9_CREATE_OK, I9_GET_OK, I9_SUBMIT_OK, I9_UPDATE_OK, SAVING } from './types';

const defaultState = {
    i9: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case I9_GET_OK:
            return { ...state, i9: action.data };

        case I9_UPDATE_OK:
            return { ...state, i9: { ...state.i9, ...action.data } };

        case I9_SUBMIT_OK:
            return { ...state };

        case I9_CREATE_OK:
            return { ...state, i9: action.data };

        default:
            return state;
    }
}

// TODO - currently ignores status, chooses pending or submitted
export function getLatestOpenI9(userId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/i9?user=${userId}&status=pending&status=submitted` })
            .then(i9s => {
                let response;
                if (i9s.length > 0) {
                    const sortedI9s = i9s.sort((a, b) => b.updated_at - a.updated_at);
                    response = sortedI9s[0];
                }
                dispatch({ type: I9_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.i9s'} defaultMessage={'Unable to retrieve I9s.'} />);
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

// TODO - currently ignores status, chooses pending or submitted
export function getSubmittedI9(userId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/i9?user=${userId}&status=submitted` })
            .then(i9s => {
                let response;
                if (i9s.length > 0) {
                    const sortedI9s = i9s.sort((a, b) => b.updated_at - a.updated_at);
                    response = sortedI9s[0];
                }
                dispatch({ type: I9_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.i9s'} defaultMessage={'Unable to retrieve submitted I9s.'} />);
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function getI9(id, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/i9/${id}` })
            .then(response => {
                dispatch({ type: I9_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function createNewI9(i9, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({
            path: '/i9',
            method: 'POST',
            body: i9
        })
            .then(response => {
                dispatch({ type: I9_CREATE_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function updateI9(i9, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/i9/${i9.id}`, method: 'PUT', body: { ...i9, admin_id: undefined } })
            .then(response => {
                dispatch({ type: I9_UPDATE_OK, data: i9 });
                dispatch({ type: COMPLETE });
                onSuccess(i9);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function submitI9(id, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/i9/${id}/action/submit`, method: 'POST' })
            .then(response => {
                dispatch({ type: I9_SUBMIT_OK });
                dispatch({ type: COMPLETE });
                onSuccess(id);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function inviteWitness(i9, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/i9/${i9.id}/action/invite_witness`, method: 'POST' })
            .then(response => {
                dispatch({ type: I9_SUBMIT_OK });
                dispatch({ type: COMPLETE });
                onSuccess(i9);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/i9s.jsx